export const testimonialsData = [
  {
    name: 'Isabella',
    country: 'USA',
    countryCode: 'US',
    text: '¡Ella es muy buena y profesional! Llegó a tiempo y planeó una lección y una presentación para repasar lo que íbamos a aprender. ¡Definitivamente estás obteniendo el valor de tu dinero!',
    rating: 5
  },
  {
    name: 'Claudia',
    country: 'Italy',
    countryCode: 'IT',
    text: 'Tuve mi primera lección con Cecilia y estoy muy satisfecha. Cecilia es una profesora muy profesional y me sentí a gusto desde el principio. Es amable y se preocupa por tus necesidades. La lección estuvo bien estructurada y Cecilia me explicó los próximos pasos para seguir mejorando mi español.',
    rating: 5
  },
  {
    name: 'Clara',
    country: 'Italy',
    countryCode: 'IT',
    text: '¡Cecilia es una gran profesora! Siempre prepara lecciones adaptadas a mi nivel y objetivos. Realmente aprecio cuánto cuidado pone en cada sesión. ¡Gracias, Cecilia!',
    rating: 5
  },
  {
    name: 'Danna',
    country: 'Spain',
    countryCode: 'ES',
    text: 'Estoy muy contenta con las clases con Cecilia. Ella es una excelente profesora: amable, paciente y profesional. Lo que más valoro es que adapta las clases según mis necesidades y objetivos, lo que hace que cada sesión sea útil y motivadora. ¡La recomiendo!',
    rating: 5
  },
  {
    name: 'Angelika',
    country: 'Germany',
    countryCode: 'DE',
    text: 'Cecilia es una muy buena profesora. Ella siempre está bien preparada y he mejorado mucho desde que comencé a estudiar con ella. Ella me quitó el miedo a hablar.',
    rating: 5
  },
  {
    name: 'Kim',
    country: 'Germany',
    countryCode: 'DE',
    text: 'Acabo de terminar mi primera clase con Cecilia y realmente la disfruté. Ella está muy comprometida y fue fácil, fluido y muy cómodo tener una conversación con ella. Sus clases parecen estar bien estructuradas y bien pensadas. ¡Estoy deseando continuar las lecciones con ella!',
    rating: 5
  },
  {
    name: 'Charlotte',
    country: 'United Kingdom',
    countryCode: 'GB',
    text: 'Cecilia es una profesora muy alentadora y amable, que me hace sentir cómoda en sus clases. Es excelente manteniéndome comprometida y motivada.',
    rating: 5
  },
  {
    name: 'Victoria',
    country: 'Austria',
    countryCode: 'AT',
    text: 'Hoy tuve mi primera lección con Cecilia y no podría estar más feliz. Ella habla en un español muy claro y clásico, con una pronunciación perfecta, lo que hace que entender sea mucho más fácil. Lo que más me impresionó fue su profesionalismo: explica la gramática y el vocabulario de una manera muy estructurada y accesible.',
    rating: 5
  },
  {
    name: 'Rüya',
    country: 'Turkey',
    countryCode: 'TR',
    text: '¡Después de mi primera clase de prueba con Cecilia, me suscribí de inmediato! Realmente tiene un enfoque muy cálido y profesional en las clases, y ya sentí que había avanzado mucho en la primera clase. Es muy evidente que Cecilia es una maestra muy capacitada y experimentada.',
    rating: 5
  },
  {
    name: 'Erica',
    country: 'Italy',
    countryCode: 'IT',
    text: 'Cecilia es una excelente profesora, disponible, simpática y te hace sentir a gusto. ¡El tiempo con ella vuela! Recomendada :)',
    rating: 5
  },
  {
    name: 'Ashley',
    country: 'USA',
    countryCode: 'US',
    text: 'Cecilia es una gran profesora. Ella está bien preparada en cada clase con revisión de gramática, discusión o nuevo vocabulario y enseña a un buen ritmo. Ella apoya mis objetivos de aprendizaje y se ha adaptado a mi estilo de aprendizaje.',
    rating: 5
  }
];